<template>
  <div>
    <div v-if="Lib.checkPower('beauty-3-ckgg',2)">
      <!-- <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane :label="'全部公告'" name="2"></el-tab-pane>
            <el-tab-pane label="未读公告" name="0"></el-tab-pane>
            <el-tab-pane label="已读公告" name="1"></el-tab-pane>
        </el-tabs>-->
      <br>
      <div class="board_header">
        <el-date-picker v-model="bulletinDate" type="daterange" placeholder="选择日期" start-placeholder="开始日期" range-separator="至" end-placeholder="结束日期" :editable="false" value-format="yyyy-MM-dd" @change="dateChange"></el-date-picker>
        <el-input ref="bulletinInput" v-model="bulletinSearch" style="width:240px;margin-left:20px;" placeholder="请输入发布人/公告标题" prefix-icon="el-icon-search" @keyup.enter.native="onBeginSearch"></el-input>
        <el-button type="primary" size="small" style="margin-left:20px;" @click="addBulletin">新增公告</el-button>
      </div>
      <br>
      <el-table tooltip-effect="light" style="width: 100%" :data="articles_arr">
        <el-table-column align="left" prop="createTime" label="发布时间" width="180" height="527">
          <template slot-scope="scope">{{ onReturnCreateTime(scope) }}</template>
        </el-table-column>
        <el-table-column align="left" prop="issuer" label="发布人" width="250"></el-table-column>
        <el-table-column align="left" prop="title" label="公告标题" width="350">
          <template slot-scope="scope">
            <span class="board_title">{{ scope.row.title }} </span>
          </template>
        </el-table-column>
        <el-table-column align="left" prop="content" label="公告内容">
          <template slot-scope="scope">
            <span class="board_title" style="width:300px">{{ scope.row.content }} </span>
          </template>
        </el-table-column>
        <el-table-column align="left" prop="readNum" label="阅读量"></el-table-column>
        <el-table-column align="left" prop="average" width="160" label="操作">
          <template slot-scope="scope">
            <el-button type="primary" size="small" @click="showUpdateDialog(scope.row)">编辑</el-button>
            <el-button size="small" @click="showDeleteDialog(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <br>
      <el-pagination background :page-size="pageSize" layout="prev, pager, next, jumper" :total="articles.length" @current-change="currentChange"></el-pagination>
      <el-dialog title="公告详情" :append-to-body="true" :visible.sync="dialogVisible" width="1101px">
        <el-container>
          <el-header>{{ bulletinDetail.title }}</el-header>
          <!-- eslint-disable-next-line vue/no-v-html -->
          <el-main v-html="bulletinDetail.content"></el-main>
          <br>
          <el-footer>
            <el-row type="flex" justify="space-between">
              <span>
                <i class="el-icon-view"></i>
                {{ bulletinDetail.readNum }}
              </span>
              <span>{{ bulletinDetail.issueTime }}</span>
            </el-row>
          </el-footer>
        </el-container>
      </el-dialog>
      <el-dialog :title="title+'公告'" :append-to-body="true" :visible.sync="dialogVisible2" :close-on-click-modal="title == '编辑'" :close-on-press-escape="title == '编辑'" width="701px" :before-close="beforeClose">
        <el-form ref="form" :model="form" label-width="80px" :rules="rules">
          <el-form-item label="公告标题" prop="title">
            <el-input v-model="form.title" placeholder="请输入公告标题" maxlength="25" style="width:240px;"></el-input>
            <span style="color: #999999;font-size: 12px;margin-left: 10px;">25个字以内</span>
          </el-form-item>
          <el-form-item label="公告内容" prop="content">
            <el-input v-model="form.content" :rows="5" type="textarea" placeholder="请输入公告内容" style="width:414px;" :maxlength="4000"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="addNewArticle">发布</el-button>
            <el-button @click="beforeClose">取消</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>
      <el-dialog title="删除公告" :append-to-body="true" :visible.sync="deleteDialog" width="701px">
        <p>确定删除这条公告吗？</p>
        <span slot="footer" class="dialog-footer">
          <el-button @click="deleteDialog = false">取 消</el-button>
          <el-button type="primary" @click="comfirmDelete">确 定</el-button>
        </span>
      </el-dialog>
    </div>
    <gt-noneData v-else :title="'暂无权限，请联系管理员分配权限'" :is-no-permission="true"></gt-noneData>
  </div>
</template>
<script>
import dayjs from 'dayjs';
import {
  queryArticles,
  checkArticle,
  deleteArticle,
  insertArticle,
  editArticle
} from './api';

export default {
  data() {
    return {
      activeName: '2',
      bulletinDate: [],
      bulletinSearch: '',
      dialogVisible: false,
      dialogVisible2: false,
      form: {
        title: '',
        content: ''
      },
      rules: {
        title: [
          { required: true, message: '标题不能为空', trigger: 'blur' }
        ],
        content: [
          { required: true, message: '内容不能为空', trigger: 'blur' },
          {
            min: 1, max: 2000, message: '长度在 2000 个字以内', trigger: 'blur'
          }

        ]
      },
      pageNo: 1,
      pageSize: 10,
      total: 0,
      articles: [],
      articles_arr: [],
      bulletinDetail: {},
      deleteDialog: false,
      deleteRow: {},
      title: '新增'
    };
  },
  activated() {
    this.onGetQueryArticles();
  },
  methods: {
    addBulletin() {
      if (this.Lib.checkPower('beauty-3-xzgg') == false) return;
      this.dialogVisible2 = true;
    },
    handleClick() {
      this.pageNo = 1;
      this.bulletinDate === null ? (this.bulletinDate = []) : '';
      this.onGetQueryArticles();
    },
    dateChange() {
      this.pageNo = 1;
      this.bulletinDate === null ? (this.bulletinDate = []) : '';
      this.onGetQueryArticles();
    },
    // 搜索
    onBeginSearch() {
      this.pageNo = 1;
      this.$refs.bulletinInput.blur();
      this.onGetQueryArticles();
    },
    // 查询公告列表页展示功能
    onGetQueryArticles() {
      const data = {
        beginTime:
                    this.bulletinDate[0] === undefined
                      ? ''
                      : this.bulletinDate[0],
        endTime:
                    this.bulletinDate[1] === undefined
                      ? ''
                      : this.bulletinDate[1],
        text: this.bulletinSearch,
        num: Number(this.activeName),
        statu: 2
      };
      queryArticles(sessionStorage.getItem('mainId'), data).then((res) => {
        this.articles_arr = [];
        this.articles = res.data;
        this.articles_arr = this.articles.slice(0, this.pageSize);
      });
    },
    // 分页切换页面
    currentChange(val) {
      val * this.pageSize > this.articles.length ? (this.articles_arr = this.articles.slice((val - 1) * this.pageSize, this.articles.length)) : (this.articles_arr = this.articles.slice((val - 1) * this.pageSize, val * this.pageSize));
    },
    // 查看公告详情
    showBulletinDetail(row) {
      this.dialogVisible = true;
      this.bulletinDetail = row;
      // console.log(this.bulletinDetail);
      checkArticle({ id: row.id }).then((res) => {
        console.log(res);
      });
    },
    // 展示删除公告dialog
    showDeleteDialog(row) {
      if (this.Lib.checkPower('beauty-3-scgg') == false) return;
      this.deleteDialog = true;
      this.deleteRow = row;
    },
    // 确认是否删除公告
    comfirmDelete() {
      deleteArticle({ id: this.deleteRow.id }).then((res) => {
        // console.log(res);
        this.deleteDialog = false;
        if (res.code === 0) {
          this.$message({ message: '删除成功', type: 'success' });
          this.bulletinDate === null ? (this.bulletinDate = []) : '';
          this.onGetQueryArticles();
        }
      });
    },
    // 新增或编辑公告
    addNewArticle() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (this.title === '新增') {
            insertArticle(
              sessionStorage.getItem('mainId'),
              this.form
            ).then((res) => {
              if (res.code === 0) {
                this.$refs.form.resetFields();
                this.dialogVisible2 = false;
                this.onGetQueryArticles();
                this.$message({ type: 'success', message: '新增成功' });
              }
            });
          } else {
            // //console.log(this.form.id)
            editArticle(sessionStorage.getItem('mainId'), this.form.id, this.form).then((res) => {
              if (res.code === 0) {
                this.$refs.form.resetFields();
                this.dialogVisible2 = false;
                this.onGetQueryArticles();
                this.title = '新增';
                this.$message({ type: 'success', message: '编辑成功' });
              }
            });
          }
        } else {
          return false;
        }
      });
    },
    // 编辑公告
    showUpdateDialog(row) {
      if (this.Lib.checkPower('beauty-3-bjgg') == false) return;
      this.title = '编辑';
      this.form = {
        title: row.title,
        content: row.content,
        id: row.id
      };
      this.dialogVisible2 = true;
    },
    // 关闭dialog前调用
    beforeClose() {
      if (this.title === '编辑') {
        this.title = '新增';
        this.form = {
          title: '',
          content: ''
        };
      }
      if (this.$refs.form) {
        this.$refs.form.resetFields();
      }
      this.dialogVisible2 = false;
    },
    onReturnCreateTime(scope) {
      return dayjs(scope.row.times).format('YYYY-MM-DD HH:mm');
    }
  }
};
</script>

<style lang="less" scoped>
.board_header {
    display: flex;
}
.el-header {
    background-color: #f5f7fa;
    height: 46px !important;
    color: #818691;
    text-align: center;
    line-height: 46px;
    font-size: 14px;
}
.el-main {
    border: solid 1px #e6ebf5;
    height: 514px;
}
.el-footer {
    padding: 0;
    height: 20px !important;
}
.board_title {
    display: inline-block;
    overflow: hidden;
    text-overflow: ellipsis;
    height: auto;
    white-space: nowrap;
    width: 250px;
    margin-top: 5px;
}
</style>
